export async function getAudioDuration(blob: Blob, audioContext: AudioContext): Promise<number> {
    return new Promise<number>((resolve) => {
      if (blob.size < 2000) {
        console.warn("Blob too small to decode; returning duration 0.");
        resolve(0);
        return;
      }
      const reader = new FileReader();
      reader.onload = async (event) => {
        try {
          const arrayBuffer = event.target?.result as ArrayBuffer;
          const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
          resolve(audioBuffer.duration);
        } catch (error) {
          console.warn("Error decoding audio data:", error);
          resolve(0);
        }
      };
      reader.onerror = (error) => {
        console.error("FileReader error:", error);
        resolve(0);
      };
      reader.readAsArrayBuffer(blob);
    });
  }

  export async function playSoundAndWait(audioElement: HTMLAudioElement, src: string): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!audioElement) {
        return reject(new Error('Audio element is not initialized.'));
      }
      audioElement.src = src;
      audioElement.onended = () => {
        audioElement.pause();
        audioElement.src = '';
        resolve();
      };
      audioElement.onerror = (e) => {
        audioElement.pause();
        reject(new Error(`Error playing sound: ${e}`));
      };
      audioElement.play().catch(err => {
        audioElement.pause();
        reject(err);
      });
    });
  }